export default __webpack_public_path__ + "static/media/1.edb18b3a.png";